import {SingleValuePropertyFilter} from './singleValuePropertyFilter';
import {QueryFilter} from './queryCreator';

export class ContainsValuePropertyFilter extends SingleValuePropertyFilter {
  solve(object: string): boolean {
    if (object === undefined || object === null) {
      return false;
    }
    return object[this.property.name].length > this.queryValue.length && object[this.property.name].toLowerCase().includes(this.queryValue.toLowerCase());
  }


  toQueryFilter(): QueryFilter {
    const result1 = new QueryFilter();

    result1.field = this.property.name;
    result1.value = this.queryValue;
    result1.operator = 'contains';
    return result1;
  }
}
